import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionFigmaTools = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"type": "page",
			"properties": {
				"title": [
					[
						"Инструменты"
					]
				]
			},
			"content": [
				"f9ca8df1-21ba-4e1e-8ff1-a6f63d577ea4",
				"7beb81a2-099f-4fa7-b09f-e96b33b2d440",
				"dbc4f160-10f0-4b9d-bf96-f28facd31fc6",
				"c1b63551-98d0-4a2f-8fe6-fc2fc0f2386b",
				"cd699234-be74-4bea-b115-3c72a40ec726",
				"ea6e0118-366d-4abd-9247-9c676e2ed8a7",
				"75e82fce-f923-42ce-a58f-020cca473aba",
				"f7b0e710-50d7-4be1-9440-43568dc9b51f",
				"83c83654-3bbd-41a7-9660-2609415d7c7d",
				"932ebac9-3e39-4239-83df-a8b829d75774",
				"c5425e59-9550-4de2-b114-d615d45384a7",
				"58eee67f-6891-451d-90e4-e10254529a14",
				"2fa1a736-c916-4bad-afb8-1b1b5579aa22",
				"d3ccdccf-157a-49c0-a39b-1d673d43cd91",
				"170d3e96-05a4-4fd0-850b-402b66762e6c",
				"ad0f6485-ed8c-418b-aa83-f14dee113508",
				"b363854e-29c8-473d-b7b6-cfc289aa1341",
				"2aef15a2-e7dd-4597-a4e6-548017d09b37",
				"45851d70-f230-438c-b98b-5cf9ad1c19d1",
				"1b6f32bc-8f6e-4e69-acb2-0e7845251942",
				"987549bd-82eb-499c-8968-73e0c836170e",
				"e364f85c-a1af-4e03-949e-d3573245661f",
				"ebd5c63c-bfba-4f90-affe-8e9942d3ff07",
				"450f5d7c-f2b9-4996-b84b-a75b8b68e8c1",
				"14df5ba5-e194-4194-bd24-56b6668e9f3a",
				"43889326-4ddc-4fcc-b796-4234e8aec5a6",
				"883bdddb-f4ab-4237-9837-3f5c8b1540e4",
				"9cdfb1e6-6c37-4895-868f-62fd606e9b0f",
				"17d74b62-21f8-4480-b40e-a7db47ebba3b",
				"ad834b6e-7f9d-4cd1-866f-563f99540c15",
				"7d3fcd5b-d7d7-43ff-acfd-e85ea92a99ea",
				"96e4e157-c36c-498e-8d4d-9808b248f92a",
				"2808257f-3ae0-4ddf-9efa-1d09a984517f",
				"b3df3bef-852f-47b7-9b2f-43d4b74db52b",
				"4e99957f-6c7b-4017-b50f-10c56e8249fe",
				"b60c7e17-68c6-4bda-92bf-73f29ffd63d7"
			],
			"format": {
				"copied_from_pointer": {
					"id": "6f111bac-261d-4c3d-97e7-eaffcd2dd9f4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"page_cover_position": 0.6
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"bc616d14-2734-493c-b6a9-31e7c52ffb3e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f9ca8df1-21ba-4e1e-8ff1-a6f63d577ea4",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/figma/tools\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9edb9380-0c06-47a7-8ee5-39eaeb010bfb",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7beb81a2-099f-4fa7-b09f-e96b33b2d440",
			"type": "header",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cb85d8ba-d202-41fd-a7f9-a10cbbfda66c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dbc4f160-10f0-4b9d-bf96-f28facd31fc6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Paradigm — дизайн-система, которая содержит всё, что нужно для создания сервисов Mail.ru. Мы пытаемся покрывать все потребности дизайнеров и постоянно работаем над развитием системы."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d84fcde2-eb3b-4c0d-b9c6-74417c570b3b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c1b63551-98d0-4a2f-8fe6-fc2fc0f2386b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Команда дизайн-системы создала в Figma библиотеки базовых инструментов с цветами и типографикой, иконки и UI-кит с компонентами."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9a65a636-22c2-4e07-bb46-ae9f3459e4b5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cd699234-be74-4bea-b115-3c72a40ec726",
			"type": "text",
			"properties": {
				"title": [
					[
						"Библиотеки Paradigm доступны всем дизайнерам и проектам в VK."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "87cb131e-8979-41bc-b2fd-3a944e3da9e6",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ea6e0118-366d-4abd-9247-9c676e2ed8a7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Также большая база знаний по работе дизайнеров собрана на нашем сайте."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "048c9102-abc5-43e1-91dc-35dc741200f0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "75e82fce-f923-42ce-a58f-020cca473aba",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4813429d-9ef7-4d12-a1eb-e1084a023235/paradigm.png"
					]
				]
			},
			"format": {
				"block_width": 1362,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4813429d-9ef7-4d12-a1eb-e1084a023235/paradigm.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5066079295154186,
				"copied_from_pointer": {
					"id": "48ad06ad-c263-41b5-89dc-289725b23c26",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"file_ids": [
				"4813429d-9ef7-4d12-a1eb-e1084a023235"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/75e82fce-f923-42ce-a58f-020cca473aba.png"
		},
		{
			"id": "f7b0e710-50d7-4be1-9440-43568dc9b51f",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://paradigm.mail.ru/"
					]
				],
				"title": [
					[
						"Дизайн-система Mail.ru Group paradigm"
					]
				],
				"description": [
					[
						"Дизайн-система Mail.ru Group paradigm. Это живой гайдлайн для продуктов под брендами Mail.ru, Mail.ru Group и My.com."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://paradigm.mail.ru/favicon/favicon-16x16.png",
				"bookmark_cover": "https://paradigm.mail.ru/favicon/og.png",
				"copied_from_pointer": {
					"id": "5f9d2830-2d80-4953-bc4d-742b23edb6e7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "83c83654-3bbd-41a7-9660-2609415d7c7d",
			"type": "header",
			"properties": {
				"title": [
					[
						"Библиотеки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b298518c-796d-4d3a-8ecb-c010138984aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "932ebac9-3e39-4239-83df-a8b829d75774",
			"type": "text",
			"properties": {
				"title": [
					[
						"Компоненты — это часто повторяющиеся элементы интерфейса: кнопки, заголовки, чекбоксы и так далее. Они помогают создавать и поддерживать консистентный дизайн внутри компании."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e0ee2485-4230-4730-aef2-b07c0a8189a0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c5425e59-9550-4de2-b114-d615d45384a7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Каждая команда в Figma имеет свой базовый набор подключенных библиотек. Получить доступ можно на вкладке "
					],
					[
						"Assets",
						[
							[
								"b"
							]
						]
					],
					[
						" или через панель стилей."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b00c6ea6-ce82-4503-b674-b453db643eb2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "58eee67f-6891-451d-90e4-e10254529a14",
			"type": "text",
			"properties": {
				"title": [
					[
						"Основная библиотека Paradigm с базовыми компонентами находится в одноименном проекте. Вы можете найти и подключить ее с помощью стандартного поиска. Также публичная версия нашей библиотеки есть в Figma Community."
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2fa1a736-c916-4bad-afb8-1b1b5579aa22",
			"type": "image",
			"properties": {
				"size": [
					[
						"145.5KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a390c16b-3ff7-404d-a1eb-7356366ed579/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a390c16b-3ff7-404d-a1eb-7356366ed579/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.6006546644844517,
				"block_preserve_scale": true
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"file_ids": [
				"a390c16b-3ff7-404d-a1eb-7356366ed579"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2fa1a736-c916-4bad-afb8-1b1b5579aa22.png"
		},
		{
			"id": "d3ccdccf-157a-49c0-a39b-1d673d43cd91",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.figma.com/community/file/1279086852572807941/paradigm-2-0"
					]
				],
				"title": [
					[
						"Paradigm 2.0 | Figma"
					]
				],
				"caption": [
					[
						"Библиотека Paradigm"
					]
				],
				"description": [
					[
						"Welcome to new Paradigm Library  Since the publication of the previous version, a lot of new things have happened in Paradigm. The basis of the update was integration with VKUI, so you may notice similarities in the components.  The main innovations in Paradigm: — Components with the Variants, Va..."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://static.figma.com/uploads/1a667ef53b7c4837049399d0593ffca39e0bec9e",
				"bookmark_cover": "https://s3-alpha.figma.com/hub/file/4085808275/7d1fe011-483a-45ed-9d2e-1fdc3377b132-cover.png"
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "170d3e96-05a4-4fd0-850b-402b66762e6c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Библиотека содержит набор цветов и типографики, который полностью повторяет тему проекта в токенах. Все цвета разделены на категории согласно которым они используются. Добавлены сразу Variables для темной и светлой темы интерфейсов. В библиотеке описаны основные компоненты интерфейса. Это компоненты VKUI с ипользованием темы Paradigm. На базе компонентов собираются основные экраны наших сервисов. На страницах компонентов дополнительно добавлена документация по их параметрам."
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad0f6485-ed8c-418b-aa83-f14dee113508",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Компоненты библиотеки разделены на Regular и Compact версию. Они соответствуют платформам на которых проектируется интерфейс. Regular для мобильных интерфейсов, Compact для web "
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b363854e-29c8-473d-b7b6-cfc289aa1341",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Локальные библиотеки проектов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0f75c6b4-08c3-4712-9b40-8924023c895c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2aef15a2-e7dd-4597-a4e6-548017d09b37",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для проектов которые наследуют Paradigm допускается создавать локальные библиотеки. В них могут хранится как копии стилей и компонентов Paradigm, так и дополнительные локальные цвета и компоненты. "
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "45851d70-f230-438c-b98b-5cf9ad1c19d1",
			"type": "image",
			"properties": {
				"size": [
					[
						"297.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d9644f69-3150-4ca6-97cf-4cb2d0d0ad5e/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d9644f69-3150-4ca6-97cf-4cb2d0d0ad5e/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.2922222222222222,
				"block_preserve_scale": true
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"file_ids": [
				"d9644f69-3150-4ca6-97cf-4cb2d0d0ad5e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/45851d70-f230-438c-b98b-5cf9ad1c19d1.png"
		},
		{
			"id": "1b6f32bc-8f6e-4e69-acb2-0e7845251942",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Мы рекомендуем для локальных библиотек использовать единые стандарты нейминга и параметров компонентов"
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "987549bd-82eb-499c-8968-73e0c836170e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Как работать с библиотеками"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b363854e-29c8-473d-b7b6-cfc289aa1341",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e364f85c-a1af-4e03-949e-d3573245661f",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Рекомендуем сделать автоматическое подключение библиотеки Paradigm при создании нового файла. Если библиотеки не подключаются автоматически, включите их вручную."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ad8340ec-8bed-4bcc-8372-7ddb17a0be9c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ebd5c63c-bfba-4f90-affe-8e9942d3ff07",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"При отрисовке элементов дизайна используйте переменные цветов Paradigm. Переключать темы интерфейсов вы сможете стандартными средствами Figma."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3d6cfacb-f9de-4ad2-8ed8-52012cc51ec9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "450f5d7c-f2b9-4996-b84b-a75b8b68e8c1",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"При работе с типографикой используйте стили текста из Paradigm"
					],
					[
						". ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8d9559e4-ca36-4a89-9b0b-8a297e56b280",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "14df5ba5-e194-4194-bd24-56b6668e9f3a",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Если нужно добавить иконку, подключите дополнительно библиотеку VKUI Icons Library. Вы сможете найти ее поиском на панели Assets. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1023f71c-1576-45a1-8465-72cb894abc69",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "43889326-4ddc-4fcc-b796-4234e8aec5a6",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"При подключенной к файлу библиотеке компоненты Paradigm находятся на вкладке Assets в папке Components. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "760bad6b-a52b-443c-a31d-f69ce7cfafa3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "883bdddb-f4ab-4237-9837-3f5c8b1540e4",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Если вы понимаете что функционала библиотеки не хватает, лучше создавать локальные компоненты внутри файла Figma. "
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9cdfb1e6-6c37-4895-868f-62fd606e9b0f",
			"type": "quote",
			"properties": {
				"title": [
					[
						"При использовании стандартных компонентов мы рекомендуем не отвязывать их от родителя, и если не хватает функционала написать ответственному за библиотеку"
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "17d74b62-21f8-4480-b40e-a7db47ebba3b",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Почему это важно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "595b0b91-35f7-4a33-97cc-0329b7e60161",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad834b6e-7f9d-4cd1-866f-563f99540c15",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Работая с компонентами, мы поддерживаем консистентность наших продуктов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5805687d-d5d2-4888-8acc-1212c9039c69",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d3fcd5b-d7d7-43ff-acfd-e85ea92a99ea",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Используя базовые компоненты вы оперативно получите обновления"
					]
				]
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "96e4e157-c36c-498e-8d4d-9808b248f92a",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Это упрощает дальнейшую реализацию разработчикам"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c6806a11-00f0-491c-8a83-120587bb3b37",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2808257f-3ae0-4ddf-9efa-1d09a984517f",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Это ускоряет работу дизайнера — не нужно тратить время на отрисовку стандартных элементов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f0dedd09-c8ca-434b-8a51-653d339534aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b3df3bef-852f-47b7-9b2f-43d4b74db52b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Это позволяет поддерживать макеты в актуальном состоянии: все изменения в библиотеках сразу передаются в другие файлы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2e78ad1b-2869-4e2b-864f-7acae1cad393",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4e99957f-6c7b-4017-b50f-10c56e8249fe",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Если вы обнаружили ошибки в библиотеках или вам неудобно ими пользоваться, напишите любому дизайнеру из команды дизайн-системы, и мы найдем решение ❤️"
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d93064ee-e2de-4f7c-b61f-6bdddefe135e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b60c7e17-68c6-4bda-92bf-73f29ffd63d7",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "2fd42246-44ff-45b2-be0c-177425d90234",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Paradigm",
			"id": "7beb81a2-099f-4fa7-b09f-e96b33b2d440"
		},
		{
			"title": "Библиотеки",
			"id": "83c83654-3bbd-41a7-9660-2609415d7c7d"
		}
	]
}} />
);

export default NotionFigmaTools;
